module.exports = __webpack_public_path__ + "img/UnknownStatus.b6e7540d.svg";